import {
  Component,
  Input,
  Output,
  EventEmitter,
  ViewChild,
} from "@angular/core";
import { KpiService } from "../../kpi/kpi.service";

@Component({
  selector: "arrow-scroll-for-tables",
  template: "",
})
export class ArrowScrollForTablesComponent {
  @ViewChild("compHead") cHead;
  @ViewChild("combinedTableBody") combTableBody;
  @ViewChild("compBody") cBody;

  rightArrowImgName: string = "keyboard_arrow_right-inactive";
  leftArrowImgName: string = "keyboard_arrow_left-inactive";
  protected tableType: string = "";
  protected quietUntil: number = 0;
  protected quietPeriod: number = 5000; //5 seconds
  showRightArrow: boolean = true;
  showLeftArrow: boolean = false;

  constructor(public kpiService: KpiService) {}

  arrowClicked(type) {
    if (
      this.cHead &&
      this.cHead.nativeElement &&
      this.cBody &&
      this.cBody.nativeElement
    ) {
      if (type == "right") {
        this.cHead.nativeElement.scrollLeft =
          this.cHead.nativeElement.scrollLeft + 120;
        this.cBody.nativeElement.scrollLeft =
          this.cBody.nativeElement.scrollLeft + 120;
      } else {
        this.cHead.nativeElement.scrollLeft =
          this.cHead.nativeElement.scrollLeft - 120;
        this.cBody.nativeElement.scrollLeft =
          this.cBody.nativeElement.scrollLeft - 120;
      }
    }
    if (this.tableType == "school" || this.tableType == "student") {
      this.kpiService
        .trackEvent(`mosaic.click.${this.tableType}.arrowScroll`)
        .subscribe();
      //Reset quietUntil, so this does not also record a mouse scroll event.
      let currentTime = new Date().getTime();
      this.quietUntil = currentTime + this.quietPeriod;
    }
  }

  highlightArrow(action: string, type: string) {
    if (action == "enter") {
      if (type == "right") {
        this.rightArrowImgName = "keyboard_arrow_right-active";
      } else {
        this.leftArrowImgName = "keyboard_arrow_left-active";
      }
    } else {
      if (type == "right") {
        this.rightArrowImgName = "keyboard_arrow_right-inactive";
      } else {
        this.leftArrowImgName = "keyboard_arrow_left-inactive";
      }
    }
  }

  showArrow(type) {
    if (this.cBody && this.cBody.nativeElement) {
      if (type == "right") {
        return (
          this.cBody.nativeElement.scrollLeft <
          this.cBody.nativeElement.scrollWidth -
            this.cBody.nativeElement.offsetWidth
        );
      } else {
        return this.cBody.nativeElement.scrollLeft > 0;
      }
    }
  }

  onScroll(scrollObj) {
    this.showRightArrow = this.showArrow("right");
    this.showLeftArrow = this.showArrow("left");
    this.trackScrollEvent();
  }

  trackScrollEvent() {
    //Rate limit tracking events to one per five second interval
    let currentTime = new Date().getTime();
    if (currentTime > this.quietUntil) {
      if (this.tableType == "school" || this.tableType == "student") {
        this.kpiService
          .trackEvent(`mosaic.click.${this.tableType}.mouseScroll`)
          .subscribe();
      }
      this.quietUntil = currentTime + this.quietPeriod;
    }
  }
}
